import { combinePath } from '../location/combinePath';

export const newInboxRootPath = '/inbox-new';

export const inboxRootPath = '/inbox';
export const inboxUnreadSubpath = '/unread';
export const inboxUnreadPageUrl = combinePath(inboxRootPath, inboxUnreadSubpath);
export const inboxDirectMessagesSubpath = '/direct';
export const inboxDirectMessagesPageUrl = combinePath(inboxRootPath, inboxDirectMessagesSubpath);
export const inboxAllSubpath = '/all';
export const inboxAllPageUrl = combinePath(inboxRootPath, inboxAllSubpath);
export const newInboxAllPageUrl = combinePath(newInboxRootPath, inboxAllSubpath);
export const newInboxUnreadPageUrl = combinePath(newInboxRootPath, inboxUnreadSubpath);
export const newInboxDirectMessagesPageUrl = combinePath(newInboxRootPath, inboxDirectMessagesSubpath);

type InboxFeedType = 'UNREAD' | 'DIRECT' | 'ALL';
type InboxPageUrl = typeof inboxUnreadPageUrl | typeof inboxDirectMessagesPageUrl | typeof inboxAllPageUrl;
const inboxMap: Record<InboxFeedType, InboxPageUrl> = {
  UNREAD: inboxUnreadPageUrl,
  DIRECT: inboxDirectMessagesPageUrl,
  ALL: inboxAllPageUrl,
};

type InboxPage = (feedType: InboxFeedType) => string;
export const inboxPage: InboxPage = (feedType) => inboxMap[feedType];
